/**
 * Admin: Add / edit real wedding only (no blog fields).
 */
import { Link } from "react-router-dom";
import "./AddRealWeddingPage.css";
import { useContentForm } from "../hooks/useContentForm";
import {
  ContentFormShell,
  ContentBasicFields,
  ContentDescriptionField,
  ContentGallerySection,
} from "../Components/ContentFormSections";

function AddRealWeddingPage() {
  const formApi = useContentForm("real_wedding");
  const {
    isEditMode,
    form,
    errors,
    success,
    coverFile,
    postLoading,
    getOneLoading,
    getOneError,
    loadTypeMismatch,
    coverInputRef,
    galleryInputRefs,
    multiFileInputRef,
    setField,
    setPhoto,
    handleCoverChange,
    handleGalleryChange,
    handleMultiSelect,
    removeCover,
    addPhoto,
    removePhoto,
    resetForAnother,
    handleSubmit,
  } = formApi;

  const listPath = "/admin/real-weddings";
  const pageTitle = isEditMode ? "Update Real Wedding" : "Add Real Wedding";
  const subtitle = success
    ? isEditMode
      ? "Real wedding has been updated."
      : "Real wedding has been added. It will appear on the Real Weddings page."
    : isEditMode
      ? "Edit heading, cover photo, description and gallery photos."
      : "Add a new real wedding story with heading, cover photo, description and gallery photos.";

  return (
    <ContentFormShell
      backTo={listPath}
      backLabel="← Real Weddings"
      title={pageTitle}
      subtitle={subtitle}
      loading={isEditMode && getOneLoading}
      loadError={isEditMode && (getOneError || loadTypeMismatch)}
      loadErrorText={
        loadTypeMismatch
          ? "This item is a blog. Open it from the Blogs list."
          : "Failed to load real wedding."
      }
      success={success}
      successTitle={isEditMode ? "Real wedding updated" : "Real wedding added"}
      successText="You can add another or go back to the list."
      onAddAnother={resetForAnother}
    >
      <form onSubmit={handleSubmit} className="admin-data-form">
        <h2 className="admin-create-business-step-title">Real wedding</h2>

        <ContentBasicFields
          idPrefix="real-wedding"
          form={form}
          errors={errors}
          postLoading={postLoading}
          coverFile={coverFile}
          coverInputRef={coverInputRef}
          setField={setField}
          handleCoverChange={handleCoverChange}
          removeCover={removeCover}
        />

        <div className="admin-form-section">
          <ContentDescriptionField
            idPrefix="real-wedding"
            form={form}
            errors={errors}
            setField={setField}
            placeholder="Story or description of the wedding (bold, lists, links supported)"
          />
        </div>

        <ContentGallerySection
          form={form}
          errors={errors}
          postLoading={postLoading}
          galleryInputRefs={galleryInputRefs}
          multiFileInputRef={multiFileInputRef}
          setPhoto={setPhoto}
          handleGalleryChange={handleGalleryChange}
          handleMultiSelect={handleMultiSelect}
          addPhoto={addPhoto}
          removePhoto={removePhoto}
          sectionTitle="Wedding photos"
        />

        <div className="admin-form-actions">
          <Link to={listPath} className="admin-form-btn admin-form-btn-cancel">
            Cancel
          </Link>
          <button
            type="submit"
            className="admin-form-btn admin-form-btn-submit"
            disabled={postLoading}
          >
            {postLoading ? "Saving…" : isEditMode ? "Update Real Wedding" : "Add Real Wedding"}
          </button>
        </div>
      </form>
    </ContentFormShell>
  );
}

export default AddRealWeddingPage;
